module.exports = {"id":"dp2_6l1q2","text":"Managing Digital Identity","instructions":"Which physical identity detail can commonly be linked to a digital identity?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.6","questionType":"PickOne","random":true,"options":[{"id":"dp2_6l1q2-a1","text":"Email address","score":1.8},{"id":"dp2_6l1q2-a2","text":"Shoe size","score":0},{"id":"dp2_6l1q2-a3","text":"Hair colour","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.6/l1q2.json
// module id = 1090
// module chunks = 41